const genericErrorMessage =
    "Well isn't that kick-you-in-the-crotch, spit-on-your-neck fantastic!?";
export { genericErrorMessage };
